var _excluded = ["listing"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getImageUrl, ListingImageSizes } from '@domain-group/fe-allhomes-library';
import Avatar from '@domain-group/fe-co-avatar';
import BedIcon from '@domain-group/fe-co-icon/lib/js/bed';
import BathIcon from '@domain-group/fe-co-icon/lib/js/bath';
import ParkingIcon from '@domain-group/fe-co-icon/lib/js/parking';
import ListingModel from '../../models/listing';
import * as styles from './small-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SmallCard = _ref => {
  var listing = _ref.listing,
    props = _objectWithoutProperties(_ref, _excluded);
  var renderFeature = (SelectedIcon, title, featureValue) => {
    if (featureValue) {
      return ___EmotionJSX("span", {
        css: styles.feature
      }, ___EmotionJSX("span", null, featureValue), ___EmotionJSX(SelectedIcon, {
        title: title,
        size: "small"
      }));
    }
    return false;
  };
  var displayStreet = () => {
    if (listing.newDevelopment && listing.propertyName) {
      return "".concat(listing.propertyName, ",");
    }
    if (listing.address.street && listing.address.street.length > 0) {
      return "".concat(listing.address.street, ",");
    }
    return ___EmotionJSX(Fragment, null, "\xA0");
  };
  return ___EmotionJSX("div", {
    css: styles.listingCard
  }, ___EmotionJSX("img", {
    css: styles.image,
    src: getImageUrl(listing.image.highRes, ListingImageSizes.MEDIUM),
    alt: ""
  }), ___EmotionJSX("div", {
    css: styles.infoSection
  }, ___EmotionJSX("div", {
    css: styles.listingInfo
  }, ___EmotionJSX("span", {
    css: styles.price
  }, listing.formattedPrice), ___EmotionJSX("a", {
    href: listing.url,
    css: styles.addressContainer,
    onClick: props.onClick
  }, ___EmotionJSX("span", {
    css: styles.addressLine
  }, displayStreet()), ___EmotionJSX("span", {
    css: styles.addressLine
  }, listing.address.suburb, " ", listing.address.state, ' ', listing.address.postcode)), ___EmotionJSX("div", {
    css: styles.featureGroup
  }, renderFeature(BedIcon, 'Bedrooms', listing.formattedBeds), renderFeature(BathIcon, 'Bathrooms', listing.formattedBaths), renderFeature(ParkingIcon, 'Parking', listing.formattedParking))), ___EmotionJSX("div", {
    css: styles.agentInfo
  }, ___EmotionJSX(Avatar, {
    css: styles.agentPhoto,
    imageUrl: listing.agent.agentPhoto,
    isBordered: true,
    colorScheme: "light",
    size: "small"
  }), ___EmotionJSX("img", {
    src: listing.agent.agencyLogo,
    css: styles.agencyLogo,
    alt: ""
  }))));
};
SmallCard.propTypes = {
  listing: PropTypes.shape(ListingModel).isRequired,
  onClick: PropTypes.func
};
SmallCard.defaultProps = {
  onClick: () => {}
};
export default SmallCard;